// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"11f56d74","453":"8796801c","461":"caae35ce","606":"1dddd38c","610":"52f98a25","633":"71b7ac59","892":"d5fc1753","940":"fb9d5fc8","941":"ddab160d"}[chunkId] + ".chunk.js";
};